import { render, staticRenderFns } from "./BaseToggle.vue?vue&type=template&id=5037a12f&scoped=true&"
import script from "./BaseToggle.vue?vue&type=script&lang=js&"
export * from "./BaseToggle.vue?vue&type=script&lang=js&"
import style0 from "./BaseToggle.vue?vue&type=style&index=0&id=5037a12f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5037a12f",
  null
  
)

export default component.exports